'use client';

import Image from '@/components/Image';
import { useTranslations } from '@/i18n/use-translations';

interface LensProcessNavPcProps {
  isDarkMode?: boolean;
}

const LensProcessNavPc = ({ isDarkMode = false }: LensProcessNavPcProps) => {
  const t = useTranslations('layout.LensProcessNav');
  const steps = [
    { img: '/layout/lens_1.png', title: t('title1'), desc: t('fullDesc1') },
    { img: '/layout/lens_2.png', title: t('title2'), desc: t('fullDesc2') },
    { img: '/layout/lens_3.png', title: t('title3'), desc: t('fullDesc3') },
    { img: '/layout/lens_4.png', title: t('title4'), desc: t('fullDesc4') },
  ];

  return (
    <section
      className={`w-[340px] shrink-0 self-stretch px-[12px] py-[20px] ${
        isDarkMode ? 'bg-[#131415] text-white' : 'bg-[#f7f7f7] text-[#282828]'
      }`}
      aria-label={t('configureYourGlasses')}
    >
      <div className="flex w-[316px] flex-col gap-[20px]">
        <b className="block font-bb text-[16px] uppercase leading-[19px] [font-weight:inherit]">
          {t('configureYourGlasses')}
        </b>

        <ol className="relative flex flex-col gap-[24px]">
          {steps.map((step, index) => (
            <li key={step.title} className="relative flex items-start gap-[12px]">
              {index === 0 ? (
                <span
                  className={`absolute left-[15.6px] top-[16px] h-[201px] border-l border-dashed ${
                    isDarkMode ? 'border-[#6c6c6c]' : 'border-[#d4d4d4]'
                  }`}
                  aria-hidden
                />
              ) : null}
              <Image
                src={step.img}
                alt=""
                width={32}
                height={32}
                className="relative z-[1] size-[31.2px] shrink-0"
              />
              <div className="flex min-w-0 flex-1 flex-col gap-[6px] text-[12px] leading-[14px]">
                <b className="block font-bb [font-weight:inherit]">{step.title}</b>
                <p className={isDarkMode ? 'text-[#a9a9a9]' : 'text-[#6c6c6c]'}>{step.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default LensProcessNavPc;
